import { getUserIdFromToken } from "../../contexts/AuthContext";
import { HTTP_POST,HTTP_GET } from "../../services/api";

export const shareExpense = async (data) => {
  try {
    const payload = {
      expenseId: data.expenseId || null,
      invoiceId: data.invoiceId || null,
      senderUserId: data.senderUserId || getUserIdFromToken(),
      invitedEmail: data.invitedEmail,
      nickname: data.nickname || "",
      isExpenseDetailsIncluded: data.isExpenseDetailsIncluded
    };

    const response = await HTTP_POST( `${process.env.REACT_APP_DOTNET_BASE_URL}/ExpenseShare/Share`, payload );
    return response.data;
  } catch (error) {
    console.error("Error sharing expense:", error);
    throw error;
  }
};

export const getSharedExpenseUsers = async (userId) => {
  try {
    const res = await HTTP_GET( `${process.env.REACT_APP_DOTNET_BASE_URL}/ExpenseShare/${userId}` );
    console.log("getSharedExpenseUsers response:", res);

    return res.data;
  } catch (error) {
    console.error("Error fetching shared users:", error);
    throw error;
  }
};

export const getSharedWithMeExpenses = async (userId) => {
  try {
    const res = await HTTP_GET(`${process.env.REACT_APP_DOTNET_BASE_URL}/ExpenseShare/SharedWithOther/${userId}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching shared-with-me expenses:", error);
    return [];
  }
};